module.exports = __webpack_public_path__ + "static/media/visa_icon.9038485c.svg";